export enum chauffageEtDiagnosticsEnum {
	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
	F = 'F',
	G = 'G'
}

export enum diagnosticsTypeEnum {
	consommationEnergetiqueBilan = 'consommationEnergetiqueBilan', // DPE
	emissionGazSerreBilan = 'emissionGazSerreBilan' // GES
}